<template>
    <div class="py-12">
        <inertia-link :href="route('kiosk.ai-skills.index')">
            <AtomicButton color="yellow" size="sm">
                {{ t("vue.ai_skills_back") }}
                <template #icon>
                    <BackspaceIcon class="mr-2 h-6 w-6" />
                </template>
            </AtomicButton>
        </inertia-link>

        <h1 class="mt-2 text-2xl font-medium tracking-small text-gray-800">
            {{ t("vue.ai_skills_edit") }}
        </h1>

        <SkillForm
            :skill="skill"
            :tools="tools"
            :models="models"
            :submit-url="route('kiosk.ai-skills.update', { aiSkill: skill.id })"
            method="put"
        />
    </div>
</template>

<script lang="ts" setup>
import route from "ziggy-js";
import { BackspaceIcon } from "@heroicons/vue/24/outline";
import { useTranslations } from "@/composables/useTranslations";
import SkillForm from "./components/SkillForm.vue";
import type {
    IInternalAiSkillFormData,
    IInternalAiSkillToolOption,
} from "@/types/AiChat/IInternalAiSkill";

defineProps<{
    skill: IInternalAiSkillFormData;
    tools: IInternalAiSkillToolOption[];
    models: string[];
}>();

const { t } = useTranslations();
</script>
